document.addEventListener('DOMContentLoaded', function () {

  window.initializeGroupedList = function () {
    const groupedListElements = document.querySelectorAll('[data-accordion-trigger]');

    groupedListElements.forEach(groupedListElement => {
      groupedListElement.addEventListener('click', groupedListElementClickHandle);
    })
  }

  function groupedListElementClickHandle(event) {
    const contentElement = document.querySelector(`[data-accordian-content="${event.target.dataset.accordionTrigger}"]`);
    contentElement.classList.toggle('d-none');
    event.target.classList.toggle('open');
  }

}, false);